/**
 * Храним флаг 18+
 */
export const adultStorageKey = "mg_adlt";

/**
 * Ключи для privide/inject
 */
export const provideKeys = {
  approved: Symbol(),
  isDialogOpened: Symbol(),
  updateApprove: Symbol(),
};
